export default "__VITE_ASSET__53b55f3f__"